module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/app_store.479de638.svg";